import { CustomButton } from "Components/CustomButton";
import styles from "./index.module.css";
import revealChat from "assets/svg/revealChat.svg";
import eye from "assets/svg/Eye.svg";

type Props = {
  unreadMessages: number;
  onReveal: () => void;
};

export const RevealChatComponent = ({ onReveal, unreadMessages }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div>
        <img src={revealChat} alt="chat img" width={48} height={48} />
        <div>
          <span>You have {unreadMessages} new messages</span>
          <span>Until revealing – the user won’t see that you’ve read the message</span>
        </div>
      </div>
      <CustomButton sizeButton="large" typeButton="primary" onClick={onReveal}>
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <img src={eye} alt="eye" width={20} height={20} /> <span>Reveal Chat</span>
        </div>
      </CustomButton>
    </div>
  );
};
